import React from 'react';
import Localize from 'react-intl-universal';

import { Formik, Form } from 'formik';

import LoginIcon from '@mui/icons-material/Login';
import LoadingButton from '@mui/lab/LoadingButton';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

import CreateFieldsFromConfig from '@components/CreateFormFields/CreateFieldsFromConfig';

import { loginConfig } from './config';
import initialValues from './initialValues';
import useCreateSchema from './useCreateSchema';

const StyledLoadingButton = styled(LoadingButton)(({ theme }) => ({
  fontWeight: '700',
  width: '45%',
  fontSize: '14px',
  textTransform: 'none',
  borderRadius: '1',
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.common.white,
  '&.MuiLoadingButton-loading': {
    width: '12rem'
  },
  '&.Mui-disabled': {
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.common.white
  },
  '&:hover': {
    backgroundColor: theme.palette.primary.light
  }
}));

const LoginForm = ({ handleSubmit = () => {}, setIsSignUp = false }) => {
  const validationSchema = useCreateSchema();

  const handleSignUp = () => {
    setIsSignUp(true);
  };

  const onSubmit = async (values, { setSubmitting }) => {
    handleSubmit(values);
    setSubmitting(false);
  };

  return (
    <Formik
      validateOnMount
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
    >
      {({ handleSubmit, isSubmitting, isValid }) => (
        <>
          <Form>
            <CreateFieldsFromConfig config={loginConfig} />
          </Form>

          <Box sx={{ display: 'flex', justifyContent: 'space-between', padding: '0', mt: 6 }}>
            <StyledLoadingButton
              disabled={!isValid}
              loading={isSubmitting}
              variant='contained'
              onClick={handleSubmit}
              endIcon={<LoginIcon />}
            >
              {Localize.get('SignIn.logIn')}
            </StyledLoadingButton>
            <StyledLoadingButton onClick={handleSignUp}>
              {Localize.get('SignIn.signUp')}
            </StyledLoadingButton>
          </Box>
        </>
      )}
    </Formik>
  );
};

export default LoginForm;
